import React from "react"
import * as styles from "./faqCategoriesContainer.module.scss"
import CategoriesList from "./categoriesList/categoriesList"
import { Link } from "gatsby"

const FAQCategoriesContainer = ({
  categories,
  setActiveCategory,
  activeCategory,
}) => (
  <div className={styles.categoryContainer}>
    <h3 className={styles.categoryHeader}>Categories</h3>
    <CategoriesList
      categories={categories}
      setActiveCategory={setActiveCategory}
      activeCategory={activeCategory}
    />
    <h3 className={styles.categoryHeader}>Still have questions:</h3>
    <div className={styles.contactButtonContainer}>
      <Link to="/contact-us" className={styles.contactButton}>
        Contact Us
      </Link>
    </div>
  </div>
)

export default FAQCategoriesContainer
